interface Props {
  fill?: string;
  className?: string;
}

const NegativeDynamic = ({
  fill = '#ec6e61',
  className = 'NegativeDynamic',
}: Props) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="5"
    height="9"
    viewBox="0 0 5 9"
    className={className}
  >
    <path
      id="Rounded-Rectangl"
      d="M0.484,6.005 C0.606,6.005 0.728,6.052 0.821,6.145 C0.821,6.145 2.000,7.325 2.000,7.325 C2.000,7.325 2.000,0.625 2.000,0.625 C2.000,0.280 2.224,-0.000 2.500,-0.000 C2.776,-0.000 3.000,0.280 3.000,0.625 C3.000,0.625 3.000,7.345 3.000,7.345 C3.000,7.345 4.199,6.145 4.199,6.145 C4.385,5.958 4.687,5.958 4.874,6.145 C5.061,6.332 5.061,6.634 4.874,6.821 C4.874,6.821 2.848,8.851 2.848,8.851 C2.758,8.940 2.637,8.991 2.510,8.991 C2.383,8.991 2.262,8.940 2.172,8.851 C2.172,8.851 0.146,6.821 0.146,6.821 C-0.040,6.634 -0.040,6.332 0.146,6.145 C0.239,6.052 0.361,6.005 0.484,6.005 z"
      fill={fill}
    />
  </svg>
);

export default NegativeDynamic;
